import {
  MATCH_TYPE_INVOICE_FUNDS_TRANSFER,
  MATCH_TYPE_INVOICE_REPAYMENT,
  MATCH_TYPE_PAYMENT_FUNDS_TRANSFER,
  MATCH_TYPE_PAYMENT_REPAYMENT,
  MATCH_TYPE_INVOICE_DD_RETURN,
  MATCH_TYPE_PAYMENT_DD_RETURN,
  MATCH_TYPE_PAYMENT_PASS_THROUGH,
} from '../match/constants'
import {BANK_TYPE_RECIPIENT, BANK_TYPE_SENDER} from '../shared/constants'

export const customerBankMap = {
  [MATCH_TYPE_PAYMENT_FUNDS_TRANSFER]: BANK_TYPE_RECIPIENT,
  [MATCH_TYPE_PAYMENT_REPAYMENT]: BANK_TYPE_SENDER,
  [MATCH_TYPE_PAYMENT_PASS_THROUGH]: BANK_TYPE_SENDER,
  [MATCH_TYPE_PAYMENT_DD_RETURN]: BANK_TYPE_SENDER,
  [MATCH_TYPE_INVOICE_FUNDS_TRANSFER]: BANK_TYPE_RECIPIENT,
  [MATCH_TYPE_INVOICE_REPAYMENT]: BANK_TYPE_SENDER,
  [MATCH_TYPE_INVOICE_DD_RETURN]: BANK_TYPE_SENDER,
}

export const tradePartnerBankMap = {
  [MATCH_TYPE_PAYMENT_FUNDS_TRANSFER]: BANK_TYPE_SENDER,
  [MATCH_TYPE_PAYMENT_REPAYMENT]: BANK_TYPE_RECIPIENT,
  [MATCH_TYPE_PAYMENT_PASS_THROUGH]: BANK_TYPE_RECIPIENT,
  [MATCH_TYPE_PAYMENT_DD_RETURN]: BANK_TYPE_RECIPIENT,
  [MATCH_TYPE_INVOICE_FUNDS_TRANSFER]: BANK_TYPE_SENDER,
  [MATCH_TYPE_INVOICE_REPAYMENT]: BANK_TYPE_RECIPIENT,
  [MATCH_TYPE_INVOICE_DD_RETURN]: BANK_TYPE_RECIPIENT,
}
